<div class="info-container">
  TELEFON KONTAKTOWY:
  <br>
  537 151 280
</div>
